
import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import TimetableList from './List';


export default class TimetableRoutes extends Component {
  render() {
    return (
      <Switch>
        <Route path={['/timetable/preview/:id', '/timetable']} exact component={TimetableList} />
      </Switch>
    );
  }
}
